import React, { FC } from "react";
import { DELIVERY_LOYALTY_TIERS } from "@/constants/loyalty-points";
import HtmlParser from "../../html-parser";
import TierLabel from "../../tierLabel";
import { DeliveryInfo } from "@/components/product/webSizes/types";
import "./style.scss";

type Props = {
  deliveryInfo?: DeliveryInfo[];
};

const CartDeliveryType: FC<Props> = ({ deliveryInfo }) => (
  <div className="selected_option option shipping_option_modal">
    <ul className="delivery_info_mobile">
      {deliveryInfo.map((deliveryOption, index: number) => (
        <li className="shipping_modal_wrapper" key={index}>
          <span>{deliveryOption.deliveryOption.label}</span>
          <span className="shipping_modal_info_mobile position-relative">
            {deliveryOption?.deliveryMessages.map((message, index) => {
              return <HtmlParser html={message} key={index} />;
            })}
            {deliveryOption.tier === DELIVERY_LOYALTY_TIERS.Black && (
              <TierLabel />
            )}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export default CartDeliveryType;
